import { create } from "zustand";

type SideBarStore = {
  isOpen: boolean;
  openSideBar: () => void;
  closeSideBar: () => void;
  toggleSideBar: () => void;
};

const useSideBarStore = create<SideBarStore>((set) => ({
  isOpen: true,
  openSideBar: () => set({ isOpen: true }),
  closeSideBar: () => set({ isOpen: false }),
  toggleSideBar: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default useSideBarStore;
